export const DpeGesNoValue = ["null", "vi", "V.I", "VI"];
